import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Linkedin } from 'lucide-react';

const Footer = () => {
  const handleSupportLinkClick = () => {
    if (window.location.pathname.includes('/contact')) {
      const el = document.getElementById('contact-form');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <footer className="bg-primary-900 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img className="h-6 w-auto" src="/assets/logos/dakhla-logo-english-white.svg" alt="Dakhla" />
            </div>
            <p className="text-slate-300 max-w-md mb-6">
              Pakistan's unified university admissions portal. Simplifying higher education access for students nationwide.
            </p>
            <div className="flex space-x-3 mt-4">
              <a
                href="https://wa.me/message/NFSXJKGLHLPGI1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-xl border border-slate-700/60 text-slate-400 hover:text-emerald-400 hover:border-emerald-400 hover:scale-105 transition-all duration-150"
                title="WhatsApp"
              >
                <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/dakhla.pk"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-xl border border-slate-700/60 text-slate-400 hover:text-white hover:border-white hover:scale-105 transition-all duration-150"
                title="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.facebook.com/dakhla.pakistan"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-xl border border-slate-700/60 text-slate-400 hover:text-white hover:border-white hover:scale-105 transition-all duration-150"
                title="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/dakhla-pk"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-xl border border-slate-700/60 text-slate-400 hover:text-white hover:border-white hover:scale-105 transition-all duration-150"
                title="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-slate-300 hover:text-white transition-colors">Universities</Link></li>
              <li>
                <Link to="/direct-apply" className="inline-flex items-center gap-2 text-slate-300 hover:text-white transition-colors">
                  DirectApply
                  <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-primary-600/50 text-white text-[9px] font-bold uppercase tracking-wide leading-none border border-primary-400/30">
                    Soon
                  </span>
                </Link>
              </li>
              <li><Link to="/about" className="text-slate-300 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/blog" className="text-slate-300 hover:text-white transition-colors">Blog</Link></li>
              <li>
                <Link
                  to="/contact#contact-form"
                  onClick={handleSupportLinkClick}
                  className="text-slate-300 hover:text-white transition-colors"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/contact?type=feedback#contact-form"
                  onClick={handleSupportLinkClick}
                  className="text-slate-300 hover:text-white transition-colors"
                >
                  Give Feedback
                </Link>
              </li>
              <li>
                <Link
                  to="/contact?type=bug#contact-form"
                  onClick={handleSupportLinkClick}
                  className="text-slate-300 hover:text-white transition-colors"
                >
                  Report a Bug
                </Link>
              </li>
              <li>
                <Link
                  to="/contact?type=partner#contact-form"
                  onClick={handleSupportLinkClick}
                  className="text-slate-300 hover:text-white transition-colors"
                >
                  Become a Partner
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-slate-300 hover:text-white transition-colors"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">Legal & Policy</h3>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-slate-300 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-slate-300 hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/disclaimer" className="text-slate-300 hover:text-white transition-colors">Trademark & Fair Use</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white/10 text-center max-w-4xl mx-auto">
          <p className="text-slate-400 text-xs leading-relaxed mb-4">
            <strong>Disclaimer:</strong> University names, logos, and trademarks belong to their respective owners and are displayed under nominative fair use for identification and directory reference only. Display does not imply official endorsement or affiliation unless designated as an Official Partner.
          </p>
          <p className="text-slate-400 text-sm">&copy; 2026 Dakhla. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;